import chalk, {
    supportsColor
} from 'chalk';

export const COLORS = supportsColor !== false;

export const RED = chalk.red;

export const YELLOW = chalk.yellow;

export const GREEN = chalk.green;

export const MAGENTA = chalk.magenta;
